import React from 'react';
import { Box, Grid } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, BarChart, Bar, CartesianGrid, Legend } from 'recharts';
import KPIGrid from '../components/KPIGrid';
import ChartCard from '../components/ChartCard';

const EngagementTab = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const { kpis, swipesSeries, likeRateSeries, sessionDurationBuckets } = data;

    return (
        <Box height="100%">
            {/* KPIs */}
            <KPIGrid kpis={kpis} />

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Avg Swipes per User">
                        <LineChart data={swipesSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis />
                             <Tooltip />
                             <Legend />
                             <Line type="monotone" dataKey="value" stroke="#8884d8" name="Swipes" />
                        </LineChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Like Rate Trend">
                        <LineChart data={likeRateSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis unit="%" />
                             <Tooltip formatter={(val) => `${val}%`} />
                             <Legend />
                             <Line type="monotone" dataKey="value" stroke="#82ca9d" name="Like Rate %" />
                        </LineChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12}>
                    <ChartCard title="Session Duration Distribution">
                        <BarChart data={sessionDurationBuckets}>
                            <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                            <XAxis dataKey="bucket" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="count" fill="#ffc658" name="Sessions" />
                        </BarChart>
                    </ChartCard>
                </Grid>
            </Grid>
        </Box>
    );
};

export default EngagementTab;
